import { appValidator } from "../../../../validation/Validation";

const rules = {
    postData: ['quote_post_data']
};

export const allFieldsValidation = (data) => {
    return appValidator.validate(data, rules, null);
};